// import mta from '@common/mta';
import eventProxy from '@/scripts/tools/eventProxy';
import user from '@/scripts/helper/user';
import dao from '@/scripts/helper/dao';
import { store } from '@/scripts/store';
import { getFileType } from '@/scripts/tools/utils';

let lastBucketList = [];
let lastPathInfo = {};
let lastResult = {};

const menu = {
  getBucketList(callback) {
    const handleRes = (err, data) => {
      if (err) {
        const { code } = err;
        if (code === 'InvalidAccessKeyId') {
          callback('InvalidAccessKeyId');
        } else if (code === 'AccessDenied') {
          callback('AccessDenied');
        } else if (code === -1) {
          callback('NetworkError');
        } else if (err) {
          callback(err);
        }
      } else if (data) {
        // 隐藏 TCB 桶
        const BucketList = (data.Buckets || [])
          .filter(item => item.Type !== 'tcb')
          .map(item => ({ Bucket: item.Name, Region: item.Location, CreateTime: item.CreationDate }));
        callback(null, BucketList);
      } else {
        window.location.reload();
      }
    };
    dao
      .getService()
      .then(data => {
        handleRes(null, data);
      })
      .catch(() => {
        dao
          .listBuckets()
          .then(data => {
            handleRes(null, data);
          })
          .catch(err => {
            handleRes(err);
          });
      });
  },

  /**
   *  获取收藏路径
   */
  getPathList(callback) {
    const handleRes = (err, data) => {
      if (err) {
        const { code } = err;
        if (code === 'InvalidAccessKeyId') {
          callback('InvalidAccessKeyId');
        } else if (code === 'AccessDenied') {
          callback('AccessDenied');
        } else if (code === -1) {
          callback('NetworkError');
        } else if (err) {
          callback(err);
        }
      } else if (data) {
        const userInfo = data.userInfo || {};
        const pathList = (data.AccessPaths && data.AccessPaths.map(v => {
          const Bucket = v.AccessPath.substr(0, v.AccessPath.indexOf('/'));
          const Prefix = v.AccessPath.substr(v.AccessPath.indexOf('/') + 1);
          return {
            Path: v.AccessPath,
            Bucket,
            Region: v.CosRegion,
            Prefix,
            CreateTime: '',
            isCollection: true,
          };
        }).sort((a, b) => {
          if (a.Path === b.Path) return 0;
          if (a.Path > b.Path) return 1;
          return -1;
        })) || [];
        callback(null, {
          userInfo,
          appId: userInfo.AppId || '',
          pathList,
          pathShow: true,
        });
      } else {
        window.location.reload();
      }
    };
    dao
      .listAccessPaths()
      .then(data => {
        handleRes(null, data);
      })
      .catch(err => {
        handleRes(err);
      });
  },

  async getResult(bucketErr, bucketList, pathError, pathInfo) {
    let allow = false;
    let message = '';
    const pathList = (pathInfo && pathInfo.pathList) || [];
    bucketList = bucketList || [];
    try {
      store.userInfo = await dao.getUserInfo();
      store.userInfo.AppId = String(store.userInfo.AppId);
    } catch (error) {
      store.userInfo = {};
    }
    const { userInfo } = store;
    const isSubUin = userInfo && userInfo.OwnerUin && userInfo.Uin && userInfo.OwnerUin !== userInfo.Uin;
    if (bucketErr === 'NetworkError' && pathError === 'NetworkError') {
      // 先处理网络错误
      message = window.lang.t('error.networkError');
    } else if (bucketErr === 'HttpsError' || pathError === 'HttpsError') {
      // 处理证书错误错误
      message = window.lang.t('error.httpsCertificateError');
    } else if (bucketErr === 'InvalidAccessKeyId') {
      // bucketList 提示无效，是密钥错误
      message = window.lang.t('error.secretIdError');
    } else if (bucketErr === 'AccessDenied' && !isSubUin) {
      // 无权限，且是主账号，则为密钥错误
      message = window.lang.t('error.secretError');
    } else if (bucketErr === 'AccessDenied' && isSubUin) {
      // 无权限，如果是子帐号提示增加权限
      allow = true;
      message = window.lang.t('error.needAccessPathOrGetServiceAccess');
    } else if (!bucketErr && !bucketList.length) {
      // 空列表
      allow = true;
      message = window.lang.t('error.bucketListEmpty');
    } else if (bucketErr && bucketErr.error && bucketErr.error.Code === 'InvalidAccessKeyId') {
      // bucketList XML 错误
      message = window.lang.t('error.secretIdError');
    } else if (bucketErr && bucketErr.error && bucketErr.error.Code === 'SignatureDoesNotMatch') {
      // bucketList XML 错误
      message = window.lang.t('error.secretError');
    } else if (bucketErr && bucketErr.error && bucketErr.error.Message) {
      // bucketList XML 错误
      message = bucketErr.error.Message;
    } else if (bucketErr && bucketErr.error) {
      // bucketList XML 错误
      message = `${window.lang.t('error.networkError')} ${bucketErr.statusCode || ''}`;
    } else if (bucketErr && bucketErr.body) {
      // bucketList XML 错误
      message = `${window.lang.t('error.networkError')} ${bucketErr.body}`;
    } else if (bucketErr && bucketErr.code === 'SignatureDoesNotMatch') {
      // unknownError1
      message = window.lang.t('error.signatureError');
    } else if (bucketErr) {
      // unknownError1
      message = `${window.lang.t('error.unknownError')} ${JSON.stringify(bucketErr)}`;
    } else if (pathError) {
      // unknownError2
      message = `${window.lang.t('error.unknownError')} ${JSON.stringify(pathError)}`;
    }
    // bucketErr && mta.clickStat('menu_getservice_error', { error: pathError });
    if (bucketList.length || pathList.length) {
      allow = true;
    }
    return {
      message,
      allow,
    };
  },
  getList(callback) {
    const cb = async (err1, bucketList, err2, pathInfo) => {
      const result = await menu.getResult(err1, bucketList, err2, pathInfo);
      lastBucketList = bucketList || [];
      lastPathInfo = pathInfo || {};
      lastResult = result || {};
      const lastData = {
        bucketList: lastBucketList,
        pathInfo: lastPathInfo,
        result: lastResult,
      };
      callback(lastData);
      eventProxy.emit('menu.ready', lastData); // 此处监听为了给 sync 同步界面使用
    };
    menu.getBucketList((err1, bucketList) => {
      menu.getPathList((err2, pathInfo) => {
        const exitList = [];
        if (pathInfo && pathInfo.pathList) {
          pathInfo.pathList.forEach(item => {
            const result = getFileType(item.Path);
            item.icon = result.icon;
            item.type = result.type;
            exitList.push(`${item.Region}-${item.Path}`);
          });
        }
        if (bucketList) {
          bucketList.forEach(item => {
            const key = `${item.Region}-${item.Bucket}/`;
            item.isCollection = exitList.includes(key);
          });
        }
        cb(err1, bucketList, err2, pathInfo);
      });
    });
  },
  getLastData() {
    return {
      bucketList: lastBucketList,
      pathInfo: lastPathInfo,
      result: lastResult,
    };
  },
  initData() {
    lastBucketList = [];
    lastResult = {};
  },
};

user.afterLogout(() => {
  // 登出后初始化
  menu.initData();
});

export default menu;
